import { useMemo, useState } from 'react';

// custom hook to create new web socket instance declared here
const useWebSocket = (socketURL: string) => {
  // integration of react hooks here
  const [socketData, setSocketData] = useState<unknown>();
  const [webSocket, setWebSocket] = useState<WebSocket | null>(null);

  // setting up new socket connection here
  useMemo(() => {
    try {
      const newSocket = new WebSocket(socketURL);

      newSocket.onerror = (err) => {
        console.log(err);
        setSocketData('');
        setWebSocket(null);
      };
      newSocket.onopen = () => setWebSocket(newSocket);
      newSocket.onmessage = (msg) => {
        try {
          console.log(
            'RAW SOCKET DATA: ',
            JSON.parse(msg.data as string).message
          );

          console.log(
            'RAW SOCKET SESSION: ',
            JSON.parse(JSON.parse(msg.data as string).message.session)
          );
        } catch (error) {}
        setSocketData(JSON.parse(msg.data as string).message);
      };
      newSocket.onclose = () => {
        console.log('SOCKET CLOSED!!');
        setSocketData('');
        setWebSocket(null);
      };
    } catch (error) {
      console.log('SOCKET ERROR: ', error);
      return null;
    }
  }, [socketURL]);

  return {
    socketData,
    webSocket,
  };
};

export default useWebSocket;
